import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Commercial Appraisals', anchor: 'commercial' },
    { name: 'Residential Appraisals', anchor: 'residential' },
    { name: 'Estate Valuations', anchor: 'estate' },
    { name: 'Divorce Appraisals', anchor: 'divorce' },
    { name: 'Tax Appeals', anchor: 'tax-litigation' },
    { name: 'Litigation Support', anchor: 'tax-litigation' },
    { name: 'Bank & Mortgage Financing Appraisals', anchor: 'bank-mortgage' },
    { name: 'Market Rent Studies & Feasibility Analysis', anchor: 'market-rent' }
  ];

  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Our Process', href: '/process' },
    { name: 'Contact', href: '/contact' },
    { name: 'Get Quote', href: '/contact' }
  ];

  const handleServiceClick = (e: React.MouseEvent, anchor: string) => {
    const currentPath = window.location.pathname;
    if (currentPath === '/services') {
      e.preventDefault();
      const element = document.getElementById(anchor);
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <footer className="bg-black-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <img 
                src="https://static.readdy.ai/image/0c5a07476bd7a7109b05d9670ab2ad74/c9f1fabad792b1ff7b704ac804cb90ec.jpeg"
                alt="Virtus Realty Appraisal Services LLC Logo"
                className="h-24 w-auto"
              />
              <div>
                <h3 className="text-xl font-bold text-white mb-1">
                  Virtus Realty Appraisal Services LLC
                </h3>
                <p className="text-yellow-400 text-sm">Certified General Appraisers</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md font-modern">
              Trusted, certified appraisal services for commercial, residential, and industrial properties. 
              Delivering precise, compliant, and timely valuation reports with integrity and exceptional service.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61584346520782" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 cursor-pointer transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://www.linkedin.com/in/PGMVirtus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 cursor-pointer transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/virtusrealtyappraisalservices/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-400 cursor-pointer transition-colors">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400 font-elegant">
              <a href="/services" className="hover:text-yellow-300 cursor-pointer">Our Services</a>
            </h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.name}>
                  <a 
                    href={`/services#${service.anchor}`}
                    onClick={(e) => handleServiceClick(e, service.anchor)}
                    className="text-gray-300 hover:text-yellow-400 cursor-pointer text-sm font-modern transition-colors"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400 font-elegant">
              <a href="/" className="hover:text-yellow-300 cursor-pointer">Quick Links</a>
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-gray-300 hover:text-yellow-400 cursor-pointer text-sm font-modern transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm font-modern">
            © {currentYear} Virtus Realty Appraisal Services LLC. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-yellow-400 text-sm cursor-pointer mt-2 md:mt-0 font-modern transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
